import React from 'react'
import { MainAside } from '../../Components/Aside'

function Verticals({ content, vidPlay }) {
  return (
    <section id={'verticals'}>
      <hr />
      <MainAside content={content.main} />
      <br />
      <br />
      <br />
      <TileGrid content={content.verticalsTiles} vidPlay={vidPlay} />
    </section>
  )
}

function TileGrid({ content, vidPlay }) {
  const tiles = content.map(vertical => (
    <Tile key={vertical.h} content={vertical} vidPlay={vidPlay} />
  ))
  return <div className={'grid-list'}>{tiles}</div>
}

function Tile({ content, vidPlay }) {
  const { h, p, video } = content
  return (
    <div className={'column-container'}>
      <div className={'vertical-tile'}>
        <video autoPlay muted loop playsInline>
          <source src={video.src} type={'video/mp4'} />
          {video.alt}
        </video>
        <h3>{h}</h3>
        <p>{p}</p>
      </div>
    </div>
  )
}

export default Verticals



// WEBPACK FOOTER //
// ./src/Views/Home/Verticals.js